import { Form, Input } from "antd";
import { max, min, required } from "../../helpers/FormRuleHelper";

const ProfileUpdateForm = () => {
  return (
    <>
      <Form.Item
        name="firstname"
        label="Ad"
        rules={[required, min(2), max(30)]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="lastname"
        label="Soyad"
        rules={[required, min(2), max(30)]}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default ProfileUpdateForm;
